import { ColorEnum } from '@/constants/color'
import CheckmarkIcon from '@/features/ui/icons/components/CheckmarkIcon'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import {
    MeasuredStyles,
    Status,
} from '@/features/ui/inputs/components/ValidationStatusMessage/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

export interface ValidationStatusMessageProps {
    message: string
    status: Status
    withIcon?: boolean
    measuredStyles: MeasuredStyles | undefined
}

const ValidationStatusMessage: FC<ValidationStatusMessageProps> = ({
    message,
    status,
    withIcon,
    measuredStyles,
}) => {
    const { styles } = useStyles(stylesheet, { status })

    if (!measuredStyles) return

    const renderIcon = () => {
        if (!withIcon) return

        if (status === 'success') {
            return <CheckmarkIcon fill={ColorEnum.EMERALD_700} style={styles.icon} />
        }

        return <CloseIcon fill={ColorEnum.BRICK_500} style={styles.icon} />
    }

    return (
        <View style={[styles.container, measuredStyles]}>
            {renderIcon()}
            <Typography.Description
                size="small"
                font="medium"
                numberOfLines={2}
                style={styles.message}
            >
                {message}
            </Typography.Description>
        </View>
    )
}

const iconSize = 16

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        maxWidth: '100%',
        gap: 4,
        position: 'absolute',
    },
    icon: {
        alignSelf: 'flex-start',
        height: iconSize,
        width: iconSize,
    },
    message: {
        flex: 1,
        variants: {
            status: {
                success: {
                    color: ColorEnum.EMERALD_700,
                },
                error: {
                    color: ColorEnum.BRICK_500,
                },
            },
        },
    },
})

export default ValidationStatusMessage
